import { render, staticRenderFns } from "./ChangePwdModal.vue?vue&type=template&id=78bfdde4"
import script from "./ChangePwdModal.vue?vue&type=script&lang=js"
export * from "./ChangePwdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports